import React, { useState } from 'react';
import './Sidebar.css';
import { FaUser, FaUserFriends } from 'react-icons/fa';
import { IoKey } from 'react-icons/io5';
import { MdOutlineAssignment, MdOutlineDashboard } from 'react-icons/md';
import { CiWavePulse1 } from 'react-icons/ci';
import { RiLogoutBoxRLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BiUser } from 'react-icons/bi';
import { Email } from '@mui/icons-material';
import axiosInstance from './axios/axios';
import { Toast } from './Common_Components/Toast';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState('Dashboard');
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false); // State for User Management sub-menu
  const navigate = useNavigate();
  const userid = localStorage.getItem('User') || ''
  // Fetch privileges from local storage
  const privileges = JSON.parse(localStorage.getItem('Previlege')) || [];

  // Utility function to check privileges
  const hasPrivilege = (privilegeName) => {
    return privileges.some((priv) => priv.PL_Name === privilegeName);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item, route) => {
    setSelectedItem(item);
    navigate(route);
  };

  const toggleUserManagement = () => {
    setIsUserManagementOpen(!isUserManagementOpen);
  };

  const handleLogout = async () => {
    const req = {
      id: userid
    }
    const response = await axiosInstance.post('/users/logout', req)
    const { success, message } = response.data
    if (success === true) {
      Toast.success(message)
      // Clear authentication token and other related data
      localStorage.removeItem('auth_token');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('Previlege');
      localStorage.removeItem('User');
      localStorage.removeItem("User_Details");
      setSelectedItem('Logout'); // Optional: update selected item for visual feedback
      navigate('/'); // Navigate to the login page
    } else {
      Toast.error(message)
    }

  };

  return (
    <>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        ☰
      </button>
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <ul className="sidebar-list">
          {/* {hasPrivilege('Dashboard') && ( */}
          <li
            className={`sidebar-item ${selectedItem === 'Dashboard' ? 'selected' : ''}`}
            onClick={() => handleItemClick('Dashboard', '/dashboard')}
          >
            <MdOutlineDashboard className="sidebar-icon" /> Dashboard
          </li>
          {/* )} */}
          {hasPrivilege('List Product') && (
            <li
              className={`sidebar-item ${selectedItem === 'Product Management' ? 'selected' : ''}`}
              onClick={() => handleItemClick('Product Management', '/product-management')}
            >
              <FaUser className="sidebar-icon" /> Product Management
            </li>
          )}
          {hasPrivilege('List Client') && (
            <li
              className={`sidebar-item ${selectedItem === 'Client Management' ? 'selected' : ''}`}
              onClick={() => handleItemClick('Client Management', '/client-management')}
            >
              <FaUserFriends className="sidebar-icon" /> Client Management
            </li>
          )}
          {hasPrivilege('List License') && (
            <li
              className={`sidebar-item ${selectedItem === 'License Management' ? 'selected' : ''}`}
              onClick={() => handleItemClick('License Management', '/license-management')}
            >
              <IoKey className="sidebar-icon" /> License Management
            </li>
          )}
          {hasPrivilege('Reports') && (
            <li
              className={`sidebar-item ${selectedItem === 'Reports' ? 'selected' : ''}`}
              onClick={() => handleItemClick('Reports', '/license-report')}
            >
              <MdOutlineAssignment className="sidebar-icon" /> Reports
            </li>
          )}

          {/* User Management with Sub-Menu */}
          {(hasPrivilege('List User') || hasPrivilege('List User Role') || hasPrivilege('User Previleges')) && (
            <li
              className={`sidebar-item ${selectedItem === 'User Management' ? 'selected' : ''}`}
              onClick={toggleUserManagement}
            >
              <BiUser className="sidebar-icon" /> User Management
            </li>
          )}
          {isUserManagementOpen && (
            <ul className="submenu-user">
              {hasPrivilege('List User Role') && (
                <li
                  className={`sidebar-subitem ${selectedItem === 'Role' ? 'selected' : ''}`}
                  onClick={() => handleItemClick('Role', '/user/Role')}
                >
                  User Role
                </li>
              )}
              {hasPrivilege('List User') && (
                <li
                  className={`sidebar-subitem ${selectedItem === 'User' ? 'selected' : ''}`}
                  onClick={() => handleItemClick('User', '/user/List')}
                >
                  User
                </li>
              )}
              {/* {hasPrivilege('User Previleges') && ( */}
              <li
                className={`sidebar-subitem ${selectedItem === 'Previleges' ? 'selected' : ''}`}
                onClick={() => handleItemClick('Previleges', '/user/previleges')}
              >
                User Previleges
              </li>
              {/* )} */}
            </ul>
          )}
          {hasPrivilege('Email Settings') && (
            <li
              className={`sidebar-item ${selectedItem === 'Email Settings' ? 'selected' : ''}`}
              onClick={() => handleItemClick('Email Settings', '/emailsettings')}
            >
              <Email className="sidebar-icon" /> Email Settings
            </li>
          )}
          {hasPrivilege('Audit Log') && (
            <li
              className={`sidebar-item ${selectedItem === 'Audit Log' ? 'selected' : ''}`}
              onClick={() => handleItemClick('Audit Log', '/audit-log')}
            >
              <CiWavePulse1 className="sidebar-icon" /> Audit Log
            </li>
          )}
          <li
            className={`sidebar-item ${selectedItem === 'Logout' ? 'selected' : ''}`}
            onClick={handleLogout}
          >
            <RiLogoutBoxRLine className="sidebar-icon" /> Logout
          </li>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
